import Pod from '../Shared/Pod';
import Title from '../Shared/Title';
import Filters from '../Shared/Filters';
import JoinLeftIcon from '@mui/icons-material/JoinLeft';
import TocIcon from '@mui/icons-material/Toc';
import { makeDate, makeDatePrint } from '../Shared/Time';

const MatchLink = props => {
    const executionLabel = x => {
        const date = makeDatePrint(makeDate({ start: x.StartTime }).date, true)
        const duration = new Date(props.item.Duration * 1000).toISOString().slice(14, 19)
        return `${date} (${duration})`
    }
    const typeMap = {
        jobs: {
            systems: x => [x.Input.source.system, x.Input.target.system],
            icons: x => null,
            label: x => x.Name,
            href: x => x?.Id && `/${props.type}/${x.Id}`,
            color: x => Filters.Jobs.Status.find(y => y.value === x.Status)?.color,
            onClick: x => null
        },
        schemas: {
            systems: x => x.SystemKey && [x.SystemKey],
            icons: x => !x.SystemKey && [<TocIcon />],
            label: x => x?.Name,
            href: x => x?.Id ? `/${props.type}/${x.Id}` : '#',
            onClick: x => null
        },
        executions: {
            systems: x => null,
            icons: x => [Filters.Executions.Status.find(y => y.value === x.Status)],
            label: x => executionLabel(x),
            href: x => x?.StateMachine && `/${props.type}/${x?.StateMachine}:${x?.ExecutionID}`,
            onClick: x => null
        },
        queries: {
            systems: x => null,
            icons: x => [<JoinLeftIcon /> ],
            label: x => x?.Name,
            href: x => x?.Id && `/${props.type}/${x.Id}`,
            onClick: x => null
        },
        descriptions: {
            systems: x => null,
            icons: x => null,
            label: x => x,
            href: x => null,
            onClick: x => null
        },
        commits: {
            systems: x => null,
            icons: x => null,
            label: x => makeDatePrint(new Date(x.commit.author.date.substring(0,10)*1000), true),
            href: x => null,
            onClick: x => x.onClick
        }
    }
    return (
        <Pod icon={null} color={props.type === "jobs" ? typeMap[props.type].color(props.item) : null}>
            <Title
                row
                href={typeMap[props.type].href(props.item)}
                label={typeMap[props.type].label(props.item)}
                systems={typeMap[props.type].systems(props.item)}
                icons={typeMap[props.type].icons(props.item)}
                onClick={typeMap[props.type].onClick(props.item)}
            />
        </Pod>
    )
}
export default MatchLink